import { CountryIso2, defaultCountries, CountryData } from 'react-international-phone';

const dialCodeToIso2 = defaultCountries.reduce<Record<string, CountryIso2>>((acc, [, iso2, dialCode]) => {
  acc[dialCode.replace(/\s+/g, '')] = iso2;
  return acc;
}, {});

export const suggestCountryFromPhone = (value?: string | null) =>
  value
    ? Object.entries(dialCodeToIso2)
        .sort(([a], [b]) => b.length - a.length)
        .find(([code]) => value.startsWith(`+${code}`))?.[1]
    : undefined;

export const normalizePhoneWithPlus = (value: string): string => {
  const trimmed = value.replace(/\s+/g, '');
  if (!trimmed) return '';
  return `+${trimmed.replace(/\D/g, '')}`;
};

export const getDialCodeByIso2 = (iso2: CountryIso2): string | undefined => {
  const country = defaultCountries.find((c: CountryData) => c[1].toUpperCase() === iso2.toUpperCase());

  return country?.[2];
};
